import React, { useEffect, useState, useRef } from 'react';
import axios from 'axios';
import { useParams } from 'react-router-dom';
import Rgpd from './rgpd';
import { Alert, Col,Row, Form, Button, Container } from 'react-bootstrap';
import ReCAPTCHA from 'react-google-recaptcha'


const InscriptionJoueur = () => {
    const [isError, setIsError] = useState(false);
    const [name, setName] = useState();
    const [prenom, setPrenom] = useState();
    const [date, setDate] = useState();
    const [contact, setContact] = useState();
    const [taille, setTaille] = useState();
    const [pied, setPied] = useState();
    const [poids, setPoids] = useState();
    const [email, setEmail] = useState();
    const [password, setPassword] = useState();
    const [confirm, setConfirm] = useState();
    const [error, setError] = useState(null);
    const [submitted, setSubmitted] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [verificationStatus, setVerificationStatus] = useState(null);
    const [data, setData] = useState('');
    const { uuid } = useParams();
    const [poste, setPoste] = useState();
    const [maillot, setMaillot] = useState();
    const [rgpdChecked, setRgpdChecked] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const apiUrl = process.env.REACT_APP_API_URL;
    const recaptcha = useRef()


    useEffect(() => {
        setIsLoading(true);
        axios.post(`${apiUrl}/verification/joueur`, {
            uuid: uuid
        })
            .then(response => {
                setVerificationStatus(response.data.success);
                setData(response.data.joueur);
                setIsLoading(false);
            })
            .catch(error => {
                setVerificationStatus(false);
                setIsLoading(false);
            });
    }, [apiUrl, uuid]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsLoading(true);
        const captchaValue = recaptcha.current.getValue()
        setEmail(data.email);
        setName(data.nom);
        setPrenom(data.prenom);

        if (!rgpdChecked) {
            setError("Veuillez accepter les conditions d'inscription pour continuer.");
            setIsLoading(false);
            return;
        } else if (!name || !email || !password || !confirm || !date || !contact || !prenom || !taille || !poids || !pied || !maillot || !poste) {
            setError("Veuillez remplir tous les champs du formulaire.");
            setIsLoading(false);
            return;
        } 
        else if (!captchaValue) {
            setError("Veuillez vérifier le captcha");
            setIsLoading(false);
            return;
          }
        else if (password !== confirm) {
            setError("Les mots de passe ne correspondent pas");
            setIsLoading(false);
            return;
        }

        try {
            await axios.post(`${apiUrl}/inscription/joueur`, {
                nom: name,
                mail: email,
                prenom: prenom,
                mdp: password,
                confirm_mdp: confirm,
                date: date,
                contact: contact,
                taile: taille,
                poid: poids,
                pied: pied,
                uid: uuid,
                poste: poste,
                maillot: maillot,
                captcha : captchaValue
            }, {
                withCredentials: true
            });
            setError(null);
            setSubmitted(true);
            setIsLoading(false);
        } catch (error) {
            setSubmitted(false);
            setIsLoading(false);
            if (error.response) {
                setError(error.response.data.message);
            } else {
                setIsError(true);
            }
        }
    };

    if (isLoading) {
      return (
      <div className="centered-content">
        <img src="/img/logo.png" alt="Logo" className="centered-logo" />
        <br/>
        <span className="loader"></span>
      </div>
      
      ); 
    }
  
    if (isError) {
      return (
          <>
            <div id="alert-message" className="alert5" >
              <strong>ERROR ! </strong><span id="alert-text"></span>
            </div>
            
          </>
      );
    }
  
  
  if (submitted && !error){ 
    return (
      <>
          <div id="alert-message" className="alert2" >
              <strong>Felicitation ! </strong>Votre inscription a été envoyée avec succès. <span id="alert-text"></span>
          </div>
     </>
    )
  }
  
  if (verificationStatus === false){
    return (
      <>
      <div id="alert-message" className="alert5" >
        <strong>ERROR ! </strong> Le lien d'inscription est invalide ou a expiré. <span id="alert-text"></span>
      </div>
    </>)
  }

    return (
        <Container style={{padding:"25px", boxShadow:"none"}}>
            {error &&
                <Alert variant="danger">{error}</Alert>
            }
            {verificationStatus === true &&
                <form onSubmit={handleSubmit}>
                    <h1 className="text-center my-4">Inscription des joueurs</h1>
                    <Rgpd showModal={showModal} setShowModal={setShowModal} setRgpdChecked={setRgpdChecked} />
                    <Row>
                      <Col md={6}>
                        <Form.Group controlId="nom">
                            <Form.Label>Nom</Form.Label>
                            <Form.Control type="text" readOnly value={data.nom} />
                        </Form.Group>
                      </Col>
                      <Col md={6}>
                        <Form.Group>
                          <Form.Label>Prénom</Form.Label>
                          <Form.Control type="text" readOnly value={data.prenom} />
                        </Form.Group>
                      </Col>
                    </Row>
                    <Form.Group>
                        <Form.Label>Date de naissance</Form.Label>
                        <Form.Control type="date" required value={date} onChange={(e) => setDate(e.target.value)} />
                    </Form.Group>
                    <Form.Group>
                        <Form.Label>Numéro de téléphone</Form.Label>
                        <Form.Control type="tel" placeholder="0490-508-401" required value={contact} onChange={(e) => setContact(e.target.value)} />
                    </Form.Group>
                    <Form.Group>
                        <Form.Label>Taille</Form.Label>
                        <Form.Control type="number" placeholder="1.81" required step="0.01" min={0} value={taille} onChange={(e) => setTaille(e.target.value)} />
                    </Form.Group>
                    <Form.Group>
                        <Form.Label>Poids</Form.Label>
                        <Form.Control type="number" placeholder="80" required value={poids} onChange={(e) => setPoids(e.target.value)} />
                    </Form.Group>
                    <Form.Group>
                        <Form.Label>Pied fort</Form.Label>
                        <Form.Control as="select" required value={pied} onChange={(e) => setPied(e.target.value)}>
                            <option>Sélectionner</option>
                            <option value="Pied Gauche">Pied gauche</option>
                            <option value="Pied Droit">Pied droit</option>
                            <option value="Ambidextre">Ambidextre</option>
                        </Form.Control>
                    </Form.Group>
                    <Form.Group>
                        <Form.Label>Poste</Form.Label>
                        <Form.Control as="select" required value={poste} onChange={(e) => setPoste(e.target.value)}>
                            <option>Sélectionner</option>
                            <option value="Attaquant">Attaquant</option>
                            <option value="Milieu">Milieu</option>
                            <option value="Défenseur">Défenseur</option>
                            <option value="Gardien">Gardien</option>
                        </Form.Control>
                    </Form.Group>
                    <Form.Group>
                        <Form.Label>Numéro de maillot</Form.Label>
                        <Form.Control type="number" placeholder="10" required min={1} max={99} value={maillot} onChange={(e) => setMaillot(e.target.value)} />
                    </Form.Group>
                    <Form.Group>
                        <Form.Label>Email</Form.Label>
                        <Form.Control type="text" readOnly value={data.email} />
                    </Form.Group>
                    <Form.Group>
                        <Form.Label>Mot de passe</Form.Label>
                        <Form.Control type="password" required value={password} onChange={(e) => setPassword(e.target.value)} />
                        <Form.Text className="text-muted">Avec au moins 12 caractères, 1 caractère spécial et 1 chiffre.</Form.Text>
                    </Form.Group>
                    <Form.Group>
                        <Form.Label>Confirmer votre mot de passe</Form.Label>
                        <Form.Control type="password" required value={confirm} onChange={(e) => setConfirm(e.target.value)} />
                    </Form.Group>
                    <br/>
                    <Form.Group>
                        <Form.Check
                            type="checkbox"
                            id="rgpd"
                            label="En soumettant ce formulaire, j'accepte que mes données personnelles soient traitées conformément aux conditions d'inscription."
                            checked={rgpdChecked}
                            onChange={() => {
                                if (!rgpdChecked) {
                                    setShowModal(true);
                                } else {
                                    setRgpdChecked(false);
                                }
                            }}
                        />
                    </Form.Group>
                    <br/>
                    <ReCAPTCHA ref={recaptcha} sitekey={process.env.REACT_APP_KEY_CAPTCHA} />
                    <br/>
                    <div className="text-center">
                      <Button variant="primary" type="submit" style={{backgroundColor:"#00E676", borderColor:'#00E676'}} disabled={!rgpdChecked}>
                        Inscription
                      </Button>
                    </div>
                </form>
            }
        </Container>
    );
};

export default InscriptionJoueur;

